module.exports = __webpack_public_path__ + "static/img/bg_kitty.15a878a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg_kitty.gif
// module id = z2Yw
// module chunks = 1